import { LoginComponent } from '@amzn/event-engine-js-utils';
import { AuthContext, IdentityProvider } from 'contexts/AuthProvider';
import React, { useCallback, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { i18nStrings as allI18nStrings } from 'utils/constants';

import { routes } from '../../constants';
import { QueryParamKey } from './types';

const SignIn = () => {
    const location = useLocation();
    const { signIn } = useContext(AuthContext);
    const i18nStrings = allI18nStrings.signIn;
    const providers = useMemo(
        () => [
            {
                name: i18nStrings.providers.email.label,
                description: i18nStrings.providers.email.description,
                isPrimaryButton: true,
                provider: IdentityProvider.OTP,
            },
            {
                name: i18nStrings.providers.amazonRetail.label,
                description: i18nStrings.providers.amazonRetail.description,
                provider: IdentityProvider.LOGIN_WITH_AMAZON,
            },
            {
                name: i18nStrings.providers.amazonInternal.label,
                description: i18nStrings.providers.amazonInternal.description,
                provider: IdentityProvider.AMAZON_FEDERATE,
            },
        ],
        []
    );
    const handleSignIn = useCallback(
        (provider: IdentityProvider) => {
            const params = new URLSearchParams(location.search);
            const redirect =
                params.get(QueryParamKey.REDIRECT) || routes.landingPage;

            signIn(provider, {
                redirect,
            });
        },
        [location]
    );

    return (
        <LoginComponent<IdentityProvider>
            header={{
                title: i18nStrings.title,
                description: i18nStrings.description,
            }}
            identityProviders={providers}
            loginWithIdentityProvider={handleSignIn}
        />
    );
};

export default SignIn;
